"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BoclipsKeycloakSecurity_1 = require("./BoclipsKeycloakSecurity");
var instance = null;
exports.default = {
    getInstance: function () { return instance; },
    createInstance: function (options, configureAxios, axiosInstance) {
        if (configureAxios === void 0) { configureAxios = true; }
        instance = new BoclipsKeycloakSecurity_1.BoclipsKeycloakSecurity({ options: options, configureAxios: configureAxios, axiosInstance: axiosInstance });
        return instance;
    },
};
